import { useElementAutoFocus } from '@/hooks/useElementAutoFocus'
import { useEscKey } from '@/hooks/useEscKey'
import { useLockFocusOnElements } from '@/hooks/useLockFocusOnElements'

import { ModalContent } from './ModalContent'
import { ModalSection, Overlay } from './styles'
import type { ModalComponentProps } from './types'

const Modal = (props: ModalComponentProps) => {
  const { isOpen, onClose } = props

  const { ref } = useEscKey(onClose)
  const modalRef = useElementAutoFocus(isOpen)
  useLockFocusOnElements(modalRef, isOpen)

  const modalContentProps = {
    ...props,
    hidden: !isOpen,
    modalRef: modalRef,
    dialogRef: modalRef,
  }

  return (
    <ModalSection role="presentation" open={isOpen} className={props.className} ref={ref}>
      <Overlay>
        <ModalContent {...modalContentProps} />
      </Overlay>
    </ModalSection>
  )
}

export default Modal
